/* eslint-disable no-console */
console.log("Hello World! (from majorlabel-sticky-contact-cta block)");
/* eslint-enable no-console */
